import { useSearchParams } from "react-router-dom";

export const useQueryParams = () => {
  const [searchParams] = useSearchParams();
  
  const getParam = (key: string): string | null => {
    return searchParams.get(key);
  };
  
  const getId = (): string | null => {
    return searchParams.get("id");
  };
  
  const getUser = (): string | null => {
    return searchParams.get("user");
  };
  
  const getAllParams = () => {
    const params: Record<string, string> = {};
    searchParams.forEach((value, key) => {
      params[key] = value;
    });
    return params;
  };
  
  return {
    getParam,
    getId,
    getUser,
    getAllParams,
    searchParams
  };
};
